module.exports = __webpack_public_path__ + "media/images/pic/courses_companies_orange-71556e4b1b9752aa203f33119a786523.svg";